import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  // Safe user parsing
  let user = null;

  try {
    const userData = localStorage.getItem("user");

    if (
      userData &&
      userData !== "undefined" &&
      userData !== "null"
    ) {
      user = JSON.parse(userData);
    }
  } catch (error) {
    console.error("Invalid user data in localStorage:", error);
    localStorage.removeItem("user");
    user = null;
  }

  const isLoggedIn = !!(
    user &&
    user.id &&
    user.name &&
    user.email
  );

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  };

  return (
    <Navbar fixed="top" expand="lg" bg="dark" variant="dark">
      <Container>
        <Navbar.Brand as={Link} to="/">
          ved@prakash
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">

            {isLoggedIn ? (
              <>
                <Nav.Link as={Link} to="/addproduct">
                  Add Product
                </Nav.Link>

                <Nav.Link as={Link} to="/updateproduct">
                  Product Listing
                </Nav.Link>

                <NavDropdown
                  title={user.email}
                  id="basic-nav-dropdown"
                >
                  <NavDropdown.Item disabled>
                    {user.name}
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  <NavDropdown.Item onClick={handleLogout}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login">
                  Login
                </Nav.Link>

                <Nav.Link as={Link} to="/register">
                  Register
                </Nav.Link>
              </>
            )}

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;